import NotificationsDropdown from './NotificationsDropdown';

export default NotificationsDropdown;
